import { CardContent, Container, Grid, Card, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  DescriptionText,
  Method1Container,
  MethodButtonContainer,
  StartButton,
} from "./style";
import { method1Data } from "../data/method1";
import { useContext } from "react";
import { UserAuthContext } from "../../../Contexts/UserAuthContext";

// DataCard component with inline styling
const DataCard = ({ title, description, bgColor, sx }) => {
  const formatDescription = (desc) => {
    return desc.map((item, index) => {
      // Split each description item at the first colon
      const colonIndex = item.indexOf(':');

      if (colonIndex !== -1) {
        const beforeColon = item.substring(0, colonIndex + 1);
        const afterColon = item.substring(colonIndex + 1);

        return (
          <Box key={index} sx={{ marginBottom: '12px' }}>
            <Typography
              variant="body2"
              component="span"
              sx={{
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              {beforeColon}
            </Typography>
            <Typography
              variant="body2"
              component="span"
              sx={{
                fontSize: '12px',
                display: 'block',
                marginTop: '4px',
                lineHeight: '1.4'
              }}
            >
              {afterColon}
            </Typography>
          </Box>
        );
      }

      // If no colon found, return normal text
      return (
        <Typography
          key={index}
          variant="body2"
          sx={{ marginBottom: '12px', lineHeight: '1.4' }}
        >
          {item}
        </Typography>
      );
    });
  };

  return (
    <Card sx={{
      backgroundColor: bgColor,
      color: "white",
      height: '100%',
      minHeight: '280px',
      fontFamily: "Roboto, sans-serif",
      ...sx
    }}>
      <CardContent sx={{ padding: '16px' }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontWeight: 'bold',
            fontSize: '18px',
            marginBottom: '16px'
          }}
        >
          {title}
        </Typography>
        <Box sx={{ fontSize: '14px' }}>
          {formatDescription(description)}
        </Box>
      </CardContent>
    </Card>
  );
};

// Main Method1 component
const Method1 = () => {
  const { AIuser } = useContext(UserAuthContext);
  const navigate = useNavigate();

  return (
    <Method1Container>
      <Container>

        <DescriptionText variant="body1">
          {/* Description text if needed */}
        </DescriptionText>

        <Box
          sx={{
            textAlign: 'center',
            fontSize: '18px',
            marginBottom: '24px',
            color: '#333',
            lineHeight: '1.6'
          }}
        >
          <Box component="span" sx={{ display: 'block', color: 'white' }}>
            No subscription, no commitments—
          </Box>
          <Box component="span" sx={{ display: 'block', color: 'white' }}>
            Create and publish AI content anytime and only pay for what you generate.
          </Box>
        </Box>

        {
          !AIuser && (
            <MethodButtonContainer>
              <StartButton
                onClick={() => navigate(`/sign-up`)}
                sx={{
                  padding: '12px 32px',
                  fontSize: '16px',
                  fontWeight: 'bold'
                }}
              >
                Start Free Now!
              </StartButton>
            </MethodButtonContainer>
          )
        }

        <Grid
          container
          spacing={2}
          sx={{
            marginTop: '48px'
          }}
        >
          {method1Data.map((data) => (
            <Grid
              key={data.id}
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              sx={{
                display: 'flex'
              }}
            >
              <DataCard
                title={data.title}
                description={data.description}
                bgColor={"#096C83"}
                sx={{
                  fontFamily: "Roboto, sans-serif",
                  width: '100%'
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Method1Container>
  );
};

export default Method1;